import { Action } from 'vuex'

export function mutationAlias<P = any, S = any>(
  mutationType: string
): Action<S, any> {
  return function({ commit }, payload: P) {
    commit(mutationType, payload)
  }
}
